// Hotjar.js

import React, { useEffect } from "react";
import { variants } from "../../constants/variants";

const Hotjar = () => {
  const HOTJAR_ID =
    window.config.VARIANT === variants.COLORIN
      ? process.env.REACT_APP_HOTJAR_ID_COLORIN
      : window.config.VARIANT === variants.PROVEEDORES
      ? process.env.REACT_APP_HOTJAR_ID_PROVEEDORES
      : process.env.REACT_APP_HOTJAR_ID_TERSUAVE;

  useEffect(() => {
    // Insert Hotjar tracking code into the head section
    const script = document.createElement("script");
    script.innerHTML = `
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:${HOTJAR_ID},hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `;
    document.head.appendChild(script);

    return () => {
      // Cleanup if necessary
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default Hotjar;
